
import { useEffect, useState } from "react";

import { useDispatch } from 'react-redux';

import { useNavigate } from "react-router";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { TipoSesionProps } from "../../interfaces/catalogos/TipoSesionInterface";

import { ActualizarTipoSesion, AgregarTipoSesion, TiposSesion } from "../../connections/catalogos/TipoSesionConnection";

export const TipoSesionPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [TipoSesion, setTipoSesion] = useState<TipoSesionProps[]>([]);

    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);

    const [idTipoSesion, setIdTipoSesion] = useState(0);
    const [descripcion, setDescripcion] = useState('');

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages(5);

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const TipoSesionselected = TipoSesion.find((elem) => elem.idTipoSesion === id);

        if (TipoSesionselected) {

            await ActualizarTipoSesion({ ...TipoSesionselected, activo: checked }).then(resp => {

                if (resp.idTipoSesion) {

                    var newArray = TipoSesion.map((elem) => {

                        if (elem.idTipoSesion === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setTipoSesion(newArray);

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 
                }

            });
        }

    }

    const handleGuardar = async () => {

        if (idTipoSesion !== 0) {

            const TipoSesionelected = TipoSesion.find((elem) => elem.idTipoSesion === idTipoSesion);

            if (TipoSesionelected) {

                setLoading(true);

                await ActualizarTipoSesion({ ...TipoSesionelected, descripcion, }).then(resp => {

                    if (resp.idTipoSesion) {

                        setTimeout(() => {

                            var newArray = TipoSesion.map((elem) => {

                                if (elem.idTipoSesion === idTipoSesion) {
                                    elem.descripcion = descripcion;
                                }

                                return elem;
                            });

                            setTipoSesion(newArray);
                            setOpenModal(false);
                            setLoading(false);

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                        }, 700);

                    }

                });
            }


        }
        else {

            const aplicacionAdd: TipoSesionProps = {
                idTipoSesion: 0,
                descripcion,
                activo: true,
            }

            setLoading(true);

            await AgregarTipoSesion(aplicacionAdd).then(resp => {

                if (resp.idTipoSesion) {

                    setTimeout(() => {

                        setTipoSesion([...TipoSesion, resp]);
                        setOpenModal(false);
                        setLoading(false);

                        dispatch( openSnackbar({ message: 'Se agregó el tipo de sesión correctamente', variant: 'success' })); 

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData(true);
            setTipoSesion([]);

            await TiposSesion().then(resp => {

                setTimeout(() => {

                    setTipoSesion(resp);
                    setLoadingData(false);

                }, 700);

            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={[{ text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de sesión' }]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    <Button startIcon={<UndoIcon />} color="secondary" variant="text" sx={{ mt: 1 }} onClick={() => navigate('/')}>
                        Regresar
                    </Button>

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={loadingData}
                        onClick={() => {

                            setIdTipoSesion(0);
                            setDescripcion('');

                            setOpenModal(true);
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'75%' }}> Descripción </TableCell>                                     
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    TipoSesion.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                    TipoSesion
                            )
                                .map(({ idTipoSesion, descripcion, activo }) => (

                                    <TableRow key={idTipoSesion} >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            {idTipoSesion}
                                        </TableCell>

                                        <TableCell>
                                            {descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={activo}
                                                onChange={(e) => handleChangeChecked(e.target.checked, idTipoSesion)}
                                            />
                               
                                            <IconButton
                                                color="primary"
                                                aria-label="edit"
                                                component="span"
                                                onClick={() => {

                                                    setIdTipoSesion(idTipoSesion);
                                                    setDescripcion(descripcion);

                                                    setOpenModal(true);
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            
                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            (TipoSesion.length === 0 && !loadingData)
                                ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                                :
                                loadingData
                                &&
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <CircularProgress size={32} />

                                    </TableCell>

                                </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            TipoSesion.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={1} sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: {TipoSesion.length}
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                    colSpan={8}
                                    count={TipoSesion.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}

                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}

                                    ActionsComponent={TablePaginationActions}

                                    labelRowsPerPage="Filas por página"
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={openModal} maxWidth='sm' fullWidth={true}>

                <DialogContent sx={ DialogContentStyle }>

                    <TextField
                        sx={{ mt: 3 }}
                        label={'Descripción'}
                        variant="outlined"
                        multiline
                        rows={4}
                        fullWidth
                        value={descripcion}
                        onChange={ (e) => setDescripcion( e.target.value ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }} 
                    />

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" disabled={loading} onClick={() => { setOpenModal(false); }}> Cancelar </Button>
                    <Button loading={loading} disabled={descripcion === ''} onClick={handleGuardar} variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}